// src/js/self-service/ManualDashboardUpdateStep.jsx
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// Mantengo tu Button para otros usos
import { Button } from '../main/Styles/Toolbar.jsx';

// Enlace con estilo de botón (evita window.open y duplicados)
const LinkButton = ({ href, children, newTab = false, download = false }) => {
  const style = {
    display: 'inline-block',
    padding: '10px 16px',
    border: 0,
    borderRadius: '6px',
    background: '#1976d2',
    color: '#fff',
    textDecoration: 'none',
    font: '600 14px/1.2 system-ui',
    cursor: 'pointer',
  };
  return (
    <a
      href={href}
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
      {...(download ? { download: '' } : {})}
      style={style}
    >
      {children}
    </a>
  );
};

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  newTab: PropTypes.bool,
  download: PropTypes.bool,
};

const ManualDashboardUpdateStep = (props) => {
  // Construye siempre una URL absoluta al Dashboard
  const base = (props.deviceURL && /^https?:\/\//i.test(props.deviceURL))
    ? props.deviceURL
    : 'http://192.168.253.1';
  // Si tu dashboard usa '#/refadmin', cambia a '/#/refadmin'
  const dashboardUrl = `${base.replace(/\/+$/, '')}/#refadmin`;

  const onClickRefresh = () => window.location.reload();

  return (
    <Fragment>
      <div>
        <strong>RDM EC9600i NETWORK SCANNER FIRMWARE UPDATE</strong>

        <p>
          We have detected that your scanner's firmware is outdated and requires one or more updates that could take approximately
          15 minutes to complete depending on your network speed. The update process will consist of two parts as detailed
          below. Please follow the steps to begin the process.
        </p>

        <strong>PART A: PRIMARY FIRMWARE UPDATE</strong>

        <ol>
          <li>
            Click the <em>PRIMARY FIRMWARE UPDATE</em> button below to access the RDM Network Scanner Dashboard. A new browser tab
            will open.
            <ul style={{ listStyleType: 'disc' }}>
              <li>Enter the Dashboard Login Credentials when prompted as shown below.</li>
            </ul>
          </li>

          <li>
            Once you are logged into the Dashboard, click <em>OK</em> when prompted that an update is available for your scanner.
          </li>

          <li>
            Click the <em>Install</em> button to begin the firmware update. Accept the license agreement prompts.
          </li>

          <li>
            After the firmware is updated, you may be prompted to install another update. If so:
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                Check the box for "EC9600i Certificate Update" and then click the <em>Install</em> button to begin the process.
              </li>
            </ul>
          </li>

          <li>
            Once the update is successfully completed, close the Dashboard browser tab.
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li style={{ marginTop: '0.5rem' }}>
                {/* Open new TAB and keep it open  */}
                <LinkButton href={dashboardUrl} newTab>
                  PRIMARY FIRMWARE UPDATE
                </LinkButton>
              </li>
              <li><strong>Dashboard Login Credentials</strong> (case sensitive)</li>
              <li>
                <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                  <li>User: <strong>administrator</strong></li>
                  <li>Password: <strong>rdm123</strong></li>
                </ul>
              </li>
            </ul>
          </li>
        </ol>

        <strong>PART B: SECONDARY FIRMWARE UPDATE</strong>

        <ol>
          <li>
            Click the <em>SECONDARY FIRMWARE UPDATE</em> button below to complete the scanner firmware update process.
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li style={{ marginTop: '0.5rem' }}>
                <Button type="button" variant="contained" color="primary" onClick={onClickRefresh}>
                  SECONDARY FIRMWARE UPDATE
                </Button>
              </li>
            </ul>
          </li>
        </ol>
      </div>


    </Fragment>
  );
};

ManualDashboardUpdateStep.propTypes = {
  deviceURL: PropTypes.string, // ej. 'http://192.168.253.1' o 'http://192.168.253.1:8080'
};

export default ManualDashboardUpdateStep;
